export default __webpack_public_path__ + "cc7dca938bc49854424a2cb3e02cbac9.png";